<template>
  <div class="message-box-bg flex-center" v-if="showWalletConnectMessageBox">
    <div class="message-box">
      <div class="message-box-gradient"></div>

      <div class="message-box-main">
        <div class="message-box-top">
          <h4 class="flex-center">
            {{ $t("home.walletConnect.messageBox.title") }}
          </h4>
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
        <div class="message-box-content">
          <div class="qr-img" v-fxloading="isQrImgLoading">
            <img :src="qrImg" alt="" />
          </div>
          <div class="but-refresh flex-center" @click="refresh">
            <i class="icon icon-refresh"></i>
            <strong>{{ $t("common.walletConnectMessageBox.refresh") }}</strong>
          </div>
          <p class="describe">{{ $t("home.walletConnect.messageBox.text") }}</p>
        </div>
        <div class="box-but">
          <ButtonCommon
            type="blueGradient"
            width="100%"
            @click="showDownloadFxWalletMessageBox = true"
          >
            <i class="icon icon-down-2x"></i>
            <strong class="text-download">{{
              $t("common.walletConnectMessageBox.getFxWallet")
            }}</strong>
          </ButtonCommon>
        </div>
      </div>
      <div class="message-box-bott">
        <template v-if="inviteAddress">
          <p class="message-box-bott-addr">
            <span>{{ $format.captureAddress(inviteAddress) }}</span>
            <span>{{ $t("common.walletConnectMessageBox.invitesText") }}</span>
          </p>
          <p class="text-min text-opacity">
            {{ $t("common.walletConnectMessageBox.onceConnectedText") }}
          </p>
        </template>
        <template v-else>
          <p class="message-box-bott-addr">
            <a
              class="a-link"
              target="_blank"
              rel="noopener noreferrer"
              :href="aLink"
              >{{ aLink }}</a
            >
          </p>
          <p class="text-min text-opacity">
            {{ $t("common.walletConnectMessageBox.inviteFriendsText") }}
          </p>
        </template>
      </div>
    </div>
    <DownloadFxWallet :showMessageBox.sync="showDownloadFxWalletMessageBox" />
  </div>
</template>
<script>
import ButtonCommon from "@/components/Common/button";
import DownloadFxWallet from "@/components/Common/downloadFxWallet.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "MessageBox",
  data() {
    return {
      showDownloadFxWalletMessageBox: false,
    };
  },
  components: {
    ButtonCommon,
    DownloadFxWallet,
  },
  props: {
    // showMessageBox: Boolean,
    qrImg: String,
    isQrImgLoading: {
      type: Boolean,
      default: false,
    },
    inviteAddress: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      showWalletConnectMessageBox: (state) =>
        state.connectWallet.showWalletConnectMessageBox,
    }),
    aLink() {
      return process.env.VUE_APP_INVITE;
    },
  },
  methods: {
    ...mapMutations(["SET_SHOW_WALLET_CONNECT"]),
    onShowMessageBox() {
      this.SET_SHOW_WALLET_CONNECT(!this.showWalletConnectMessageBox);
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  mounted() {
    // window.localStorage.removeItem("walletconnect");
  },
};
</script>
<style lang="scss" scoped>
.message-box-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.68);
  flex-direction: column;
  .message-box-main {
    padding: 24px 24px 40px;
    background: #1e1f23;
    border-radius: 20px;
  }
  .message-box-bott {
    padding: 24px 40px;
    box-sizing: border-box;
    border-radius: 20px;

    .text-min {
      text-align: center;
      width: 320px;
      line-height: 20px;
      margin: 0 auto;
    }

    .message-box-bott-addr {
      margin-bottom: 10px;
      text-align: center;
      .a-link {
        text-align: center;
        font-size: 14px;
        background-image: linear-gradient(90deg, #18eed8 0%, #a6f616 100%);
        -webkit-background-clip: text;
        color: transparent;
      }

      span {
        &:first-child {
          color: #a6f616;
          margin-right: 12px;
        }
      }
    }
  }
  .message-box {
    position: relative;
    width: 480px;
    background: #101314;
    border-radius: 24px;
    z-index: 9999;
    overflow: hidden;

    .message-box-gradient {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 40px;
      background-image: linear-gradient(90deg, #18eed8 1%, #a6f616 100%);
      border-radius: 24px;
      filter: blur(49px);
      z-index: 0;
    }
    .message-box-top {
      position: relative;
      margin-bottom: 40px;
      .icon-close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .but-refresh {
      opacity: 0.5;
      margin-top: 16px;
      cursor: pointer;
      &:hover {
        opacity: 1;
        strong {
          text-decoration: underline;
        }
      }
    }
    .box-but {
      min-width: 164px;
      max-width: 220px;
      margin: 0 auto;

      .text-download {
        font-size: 16px;
        margin-left: 8px;
      }
    }
    .message-box-content {
      text-align: center;

      .qr-img {
        position: relative;
        margin: 0 auto;
        box-sizing: border-box;
        width: 212px;
        height: 212px;
        padding: 8px;
        background: $lighten-color;
        border-radius: 12px;
        img {
          width: 100%;
        }
      }

      .describe {
        display: block;
        padding: 16px 0 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.qr-img {
  .loading-wrap {
    background: #1e1f23;
  }
}
</style>
